import { useState } from 'react';
import { toast } from 'react-toastify';
import accountHelpers from '../../../../utils/accountHelpers';
import AttentionModal from '../../../_common/Modal/AttentionModal/AttentionModal';
import Api from '../../../../api/api';

const ResetPasswordModal = ({ onClose, userId, isOpen }) => {
  const [saveLoading, setSaveLoading] = useState(false);

  const changePasswordClick = async () => {
    setSaveLoading(true);

    const requestData = {
      userId: accountHelpers.getUser().id,
      targetUserId: userId,
      callbackUrl: `${window.location.origin}/account/setpass`,
    };

    try {
      await Api.getReqChangePassword(requestData);
      onClose();

      toast.success("Password setup instructions have been sent to the user's email.");
    } catch (e) {
      console.warn(e);
    }

    setSaveLoading(false);
  };

  return (
    <AttentionModal
      isOpen={isOpen}
      onClose={onClose}
      title="Are you sure you want to reset this user's password?"
      zIndex={31}
      onSave={changePasswordClick}
      loading={saveLoading}
    />
  );
};

export default ResetPasswordModal;
